import { render, staticRenderFns } from "./MajEvent.vue?vue&type=template&id=220e4f06&scoped=true&"
import script from "./MajEvent.vue?vue&type=script&lang=js&"
export * from "./MajEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220e4f06",
  null
  
)

export default component.exports